import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58d041ac")

_pushScopeId("data-v-58d041ac")
const _hoisted_1 = { class: "shell  info-container info-padding" }
const _hoisted_2 = { class: "info-label-title" }
const _hoisted_3 = { class: "info-label-content" }
const _hoisted_4 = { class: "flex1 display-flex justify-content-end margin-bottom30px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_property_bread_crumb = _resolveComponent("property-bread-crumb")
  const _component_add_button = _resolveComponent("add-button")
  const _component_list_pagination = _resolveComponent("list-pagination")
  const _component_set_sub_dialog = _resolveComponent("set-sub-dialog")
  const _component_payment_tips_dialog = _resolveComponent("payment-tips-dialog")
  const _component_pay_app = _resolveComponent("pay-app")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_property_bread_crumb, { headers: _ctx.breadHeaders }, null, 8, ["headers"]),
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.infoData, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          class: ['info-item',index !== _ctx.infoData.length - 1?'info-item-bottom':''],
          key: item
        }, [
          _createVNode("label", _hoisted_2, _toDisplayString(item.label), 1),
          _createVNode("label", _hoisted_3, _toDisplayString(item.content), 1),
          (item.name==='Name')
            ? (_openBlock(), _createBlock("i", {
                key: 0,
                class: "el-icon-my-modify family-master-icon",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.routerToEdit && _ctx.routerToEdit(...args)))
              }))
            : _createCommentVNode("", true)
        ], 2))
      }), 128)),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_add_button, { onClick: _ctx.add }, null, 8, ["onClick"])
      ]),
      _createVNode(_component_list_pagination, {
        headers: _ctx.headers,
        requestData: _ctx.requestData,
        update: _ctx.updateList,
        action: _ctx.action,
        showDefaultAction: ['edit','delete'],
        "delete-url": _ctx.deleteUrl,
        deleteMultipleUrl: _ctx.deleteUrl,
        onEdit: _ctx.edit
      }, null, 8, ["headers", "requestData", "update", "action", "delete-url", "deleteMultipleUrl", "onEdit"]),
      (_ctx.isShowSetSubDialog)
        ? (_openBlock(), _createBlock(_component_set_sub_dialog, {
            key: 0,
            opera: _ctx.opera,
            "main-id": _ctx.id,
            "sub-form-data": _ctx.subFormData,
            "main-email": _ctx.mainEmail,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShowSetSubDialog=false)),
            onSubmit: _ctx.submit
          }, null, 8, ["opera", "main-id", "sub-form-data", "main-email", "onSubmit"]))
        : _createCommentVNode("", true),
      (_ctx.isShowTips)
        ? (_openBlock(), _createBlock(_component_payment_tips_dialog, {
            key: 1,
            onIsShowPayNow: _ctx.isShowPayNow,
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowTips=false)),
            mainId: _ctx.parentId,
            "notice-type": _ctx.noticeType,
            "notice-main-code": _ctx.noticeMainCode,
            projectType: _ctx.projectType
          }, null, 8, ["onIsShowPayNow", "mainId", "notice-type", "notice-main-code", "projectType"]))
        : _createCommentVNode("", true),
      (_ctx.isShowPay)
        ? (_openBlock(), _createBlock(_component_pay_app, {
            key: 2,
            mainId: _ctx.parentId,
            id: _ctx.payAppId,
            onSuccess: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateList++)),
            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowPay=false))
          }, null, 8, ["mainId", "id"]))
        : _createCommentVNode("", true)
    ])
  ]))
})